import { render, staticRenderFns } from "./MobilePrescription.vue?vue&type=template&id=38b5f152&scoped=true"
import script from "./MobilePrescription.vue?vue&type=script&lang=js"
export * from "./MobilePrescription.vue?vue&type=script&lang=js"
import style0 from "./MobilePrescription.vue?vue&type=style&index=0&id=38b5f152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5f152",
  null
  
)

export default component.exports